import { render, staticRenderFns } from "./book-note.vue?vue&type=template&id=54e7204e&scoped=true"
import script from "./book-note.vue?vue&type=script&lang=js"
export * from "./book-note.vue?vue&type=script&lang=js"
import style0 from "./book-note.vue?vue&type=style&index=0&id=54e7204e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e7204e",
  null
  
)

export default component.exports